import { createObjectLayoutRenderer } from '@web-config-app/entity-form';
import { ObjectPrimitiveArrayItemLayout } from '../layouts/object-primitive-array-item-layout/object-primitive-array-item-layout.component';
import { FlowNodeArrayItemLayout } from '../layouts/flow-node-array-item-layout/flow-node-array-item-layout.component';
import { ObjectCompoundLayout } from '../layouts/object-compound/object-compound-layout.component';
import { ObjectPrimitiveLayout } from '../layouts/object-primitive/object-primitive-layout.component';
import {
  isObjectWithHeaderLayout,
  isPrimitiveObjectArrayItemLayout,
  isPrimitiveObjectLayout,
  isFlowNodeArrayItemLayout,
} from '../testers/layout-testers';

/**
 * Object Layouts
 */

export const objectPrimitiveLayoutRenderer = createObjectLayoutRenderer(
  isPrimitiveObjectLayout,
  ObjectPrimitiveLayout,
);

export const objectCompoundLayoutRenderer = createObjectLayoutRenderer(
  isObjectWithHeaderLayout,
  ObjectCompoundLayout,
);

export const objectPrimitiveArrayItemLayoutRenderer =
  createObjectLayoutRenderer(
    isPrimitiveObjectArrayItemLayout,
    ObjectPrimitiveArrayItemLayout,
  );

export const flowNodeArrayItemLayoutRenderer = createObjectLayoutRenderer(
  isFlowNodeArrayItemLayout,
  FlowNodeArrayItemLayout,
);
